<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Interface setting</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Interface setting</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <img src="/assets/images/loader.svg" alt="" />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'InterfaceSettingList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Audra</strong> {{ value.ap_wi_mac }}</li>

                  <li><strong>Account ID</strong> {{ value.accountId }}</li>

                  <li><strong>IP Address</strong> {{ value.ip_addr }}</li>

                  <li><strong>DHCP</strong> {{ value.is_dhcp }}</li>

                  <li><strong>Start IP</strong> {{ value.start_ip }}</li>

                  <li><strong>END IP</strong> {{ value.end_ip }}</li>

                  <li><strong>Subnet Mask</strong> {{ value.subnet_mask }}</li>

                  <li>
                    <strong>Adv Interface</strong> {{ value.adv_interface }}
                  </li>

                  <li><strong>Multilan</strong> {{ value.multilan }}</li>

                  <li><strong>Network2</strong> {{ value.network2 }}</li>

                  <li>
                    <strong>LAN Port</strong> {{ value.network2_lanport }}
                  </li>

                  <li><strong>Network2 IP</strong> {{ value.network2_ip }}</li>

                  <li>
                    <strong>Network2 Subnet</strong> {{ value.network2_subnet }}
                  </li>

                  <li>
                    <strong>Network2 DHCP</strong> {{ value.network2_dhcp }}
                  </li>

                  <li>
                    <strong>Network2 Start IP</strong>
                    {{ value.network2_startip }}
                  </li>

                  <li>
                    <strong>Network2 END IP</strong> {{ value.network2_endip }}
                  </li>

                  <li><strong>Network3</strong> {{ value.network3 }}</li>

                  <li>
                    <strong>Network3 LAN Port</strong>
                    {{ value.network3_lanport }}
                  </li>

                  <li><strong>Network3 IP</strong> {{ value.network3_ip }}</li>

                  <li>
                    <strong>Network3 Subnet</strong> {{ value.network3_subnet }}
                  </li>

                  <li>
                    <strong>Network3 DHCP</strong> {{ value.network3_dhcp }}
                  </li>

                  <li>
                    <strong>Network3 Start IP</strong>
                    {{ value.network3_startip }}
                  </li>

                  <li>
                    <strong>Network3 END IP</strong> {{ value.network3_endip }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from '@/services/api'
import axios from 'axios'
const fileDownload = require('js-file-download')
import { Notification } from 'element-ui'

export default {
  name: 'InterfaceSettingShow',
  metaInfo: {
    title: 'Interface setting | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: 'arraybuffer' })
        .then(response => {
          fileDownload(response.data, url.replaceAll('/', '-'))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({
            title: 'Download Failed',
            message: 'Failed to download',
            type: 'error'
          })
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/interface_settings/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {})
      })
    }
  }
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
